<div class="body-xs text-center text-content-text-body-primary">
  <span>Ihre Daten werden vertraulich behandelt und nicht gespeichert. Der Chatbot kann potenziell Fehler machen.

    <core-popover #popover placement="top-end" [offset]="offset">
      <a class="text-parent text-content-text-body-primary" slot="anchor" (click)="popover.toggle()">Rechtliche Hinweise</a>
      <svs-popover-option-list [options]="links" (selected)="$event.onClick?.();popover.toggle()" slot="popover">
        <ng-template let-link>
          <core-link variant="secondary" [href]="link.href" [icon]="link.href ? 'open_in_new' : 'chevron_right'">{{link.name}}</core-link>
        </ng-template>
      </svs-popover-option-list>
    </core-popover>
  </span>
</div>
